import React, { useEffect, useState } from "react";
import styles from "./scss/taskcreate.module.scss";
//import ReactQuill from 'react-quill'; // Typescript
import { Select, DatePicker } from 'antd';
import 'react-quill/dist/quill.snow.css';
import { URButton } from "../../../shared/widgets/button";
import { URInput } from "../../../shared/widgets/input";
import { useSelector } from "react-redux";
import { userStatusColor } from "../../../base/callService/common";
import { getcontactDetail, SearchFilter } from "../../../base/utils";
import store from "../../../context/store/store";
import { chats, chatwindowDetails, contacts, contactwindowDetails,
  initialStateModel, LoginState } from "../../../models/model";
import { URStatusDot } from "../../../shared/widgets/avatarGroup/statusDot";
import taskimg2 from "../../../styles/images/task2.svg";
import { contactService } from "../../../base/contactService";
import { chatSideWindow } from "../../../base/eventService/eventApiService";
import { URAvatarGroup } from "../../../shared/widgets/avatarGroup";
import { ChatService } from "../../../base/chatService";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment";
type TaskPageState ={
  taskName:string,
  description:string,
  nameError:boolean,
  assigneeError:boolean,
  dueDate:Date,
  dueError:boolean,
  assigneeArray:any,
  key:any
}

export default function CreateTask(props:any){
  let isContact= window.location.pathname=== "/contacts"?true:false;
  let { contactWindowDetails}:contactwindowDetails =
  useSelector((state: initialStateModel) =>state.contactWindowReducer);
  const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const { Option } = Select;
  //const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const chatWindow: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  let {chatWindowDetails ,isMySpace}=chatWindow;
  const chat_reducer: chats = useSelector((state: initialStateModel) => state.chatReducer);

  let {workContacts} :contacts =useSelector((state: initialStateModel) =>state.contactReducer);
  const [createTask, setcreateTask] = useState<TaskPageState>({ taskName:"",description:"",key:"",
    nameError:false,assigneeError:false, dueDate:new Date(), dueError:false,assigneeArray:[]});
   
 
  const [selectMember, setselectMember] = useState({
    contactList: workContacts, searchContactList: workContacts,contactDetail:[],
    selectedmember:[]
  });

  const disabledDate = (from: any, current: any) => {
    return new Date(from.setDate(from.getDate() - 1)) >= current;
  };

  useEffect(() => {
    let selectedContact:any=[];
   
    if(isContact && 'sip_login_id'in contactWindowDetails){
      selectedContact.push(contactWindowDetails.sip_login_id);
      let contactDetials:any=[];
      contactDetials.push(contactWindowDetails);
      setcreateTask({...createTask, assigneeArray:selectedContact});
      setselectMember({...selectMember,contactDetail:contactDetials, selectedmember:selectedContact});
    }
    else if(!isMySpace && 'sip_login_id'in chatWindowDetails){
      
      let contactDetials:any=[];
      contactDetials.push(chatWindowDetails);
      if(loginDetails?.userdetails?.sip_login_id !== chatWindowDetails?.sip_login_id){
        selectedContact.push(chatWindowDetails.sip_login_id);
      }
      setcreateTask({...createTask, assigneeArray:selectedContact});
      setselectMember({...selectMember,contactDetail:contactDetials, selectedmember:selectedContact});
    }
    else {
      //setcreateTask({...createTask, assigneeArray:selectedContact});
      setselectMember({...selectMember,contactDetail:[], selectedmember:[]});
    }
    //setselectMember({...selectMember,searchContactList:workContacts,contactList: workContacts});
    

  }, [contactWindowDetails,chatWindowDetails]);

  const onSaveTask=()=>{
   
    if((createTask.taskName.trim() === "" && selectMember.selectedmember.length < 1 && createTask.dueDate === "")){
      setcreateTask({...createTask,nameError:true, assigneeError:true, dueError:true});
    }else if(createTask.taskName.trim() === ""){
      setcreateTask({...createTask,nameError:true});
    }else if(selectMember.selectedmember.length < 1){
      setcreateTask({...createTask, assigneeError:true});
    }
    
    else if(!createTask.dueDate){
      setcreateTask({...createTask,dueError:true});
    }
    else
    {
      let assigneeArray:any= [];
      selectMember?.contactDetail.map((list:any)=>(
        assigneeArray.push(list.jid)
      ));
      
      contactService.createContactTask(createTask);
      if(isContact){
        contactService.contactSideWindow(!contactWindowDetails.isWindowSlide,"tasklist",{});
        ChatService.saveChatHighlight(false,{});
        ChatService.filesHighlight(false,{});
        props.handleToggle();
        }   else if(isMySpace) {
          chat_reducer.isWindowSlide && ChatService.rightSideToogle();
      } 
      else {
        chatSideWindow(true,"tasklist",{});
      }
        setcreateTask({...createTask, taskName:"",description:"",nameError:false, assigneeError:false});
        
      // if(isContact){
      //   let assigneeArray:any= [];
      //   selectMember?.contactDetail.map((list:any)=>{
      //     assigneeArray.push(list.jid);
      //   });
      //   console.log("createTask.dueDate",createTask.dueDate);
      //   let data:any = {
      //     "summary": createTask.taskName,
      //     "description": createTask.description,
      //     "attachments": [],
      //     "attendee": assigneeArray,
      //     "dtstart": "",
      //     "dtend": createTask.dueDate ?  (new Date(createTask.dueDate).getTime() / 1000).toFixed(0):"",
      //     "due_time":"",
      //     "recur_options": "",
      //     "stop_recur": "",
      //     "priority": "",
      //     "taskStatus":"",
      //     "percentage":"",
      //     "report_to":'team_id' in contactWindowDetails ? [] :[contactWindowDetails.jid],
      //     "rrule": "",
      //     sender: {
      //       jid: 'team_id' in contactWindowDetails ? xmppDetails.jid : xmppDetails.id,
      //       sipid: userdetails.sip_login_id
      //     },
      //     receiver: {
      //       jid: contactWindowDetails.jid,
      //       sipid: 'team_id' in contactWindowDetails ?
      // `con${contactWindowDetails.team_id}` : contactWindowDetails.sip_login_id.toString()
      //     },
      //     group_id: 'team_id' in contactWindowDetails ?
      //   `con${contactWindowDetails.team_id}` : "",
      //     "status": false,
      //     "action": "",
      //     "trigger":"",
      //     "duration":"",
      //     "reporter_status":"",
      //     "creator_status": "In progress",
      //     "last_updated_by": "",
      //     "thread_id": "",
      //     "completed": {
      //       "percentage": [
      //       ],
      //       "type": "",
      //       "assignee": []
      //     }
      //   };
      //   console.log("TAsk ",data);
      //   contactService.createContactTask(data);
      //   setcreateTask({...createTask, taskName:"",description:"",nameError:false, assigneeError:false});
      //   props.handleToggle();
      // }
      // else{
      //   let assigneeArray:any= [];
      //   selectMember?.contactDetail.map((list:any)=>{
      //     assigneeArray.push(list.jid);
      //   });
      //   let data:any = {
      //     "summary": createTask.taskName,
      //     "description": createTask.description,
      //     "attachments": [],
      //     "attendee": assigneeArray,
      //     "dtstart": "",
      //     "dtend": createTask.dueDate ?  (new Date(createTask.dueDate).getTime() / 1000).toFixed(0):"",
      //     "due_time":"",
      //     "recur_options": "",
      //     "stop_recur": "",
      //     "priority": "",
      //     "taskStatus":"",
      //     "percentage":"",
      //     "report_to":'team_id' in contactWindowDetails ? [] :[contactWindowDetails.jid],
      //     "rrule": "",
      //     sender: {
      //       jid: 'team_id' in chatWindowDetails ? xmppDetails.jid : xmppDetails.id,
      //       sipid: userdetails.sip_login_id
      //     },
      //     receiver: {
      //       jid: chatWindowDetails.jid,
      //       sipid: 'team_id' in chatWindowDetails ?
      // `con${chatWindowDetails.team_id}` : chatWindowDetails.sip_login_id.toString()
      //     },
      //     group_id: 'team_id' in chatWindowDetails ?
      //   `con${chatWindowDetails.team_id}` : "",
      //     "status": false,
      //     "action": "",
      //     "trigger":"",
      //     "duration":"",
      //     "reporter_status":"",
      //     "creator_status": "In progress",
      //     "last_updated_by": "",
      //     "thread_id": "",
      //     "completed": {
      //       "percentage": [
      //       ],
      //       "type": "",
      //       "assignee": []
      //     }
      //   };
      //   contactService.createContactTask(data);
      //   setcreateTask({...createTask, taskName:"",description:"",nameError:false, assigneeError:false});
       
      
      //   chatSideWindow(true,"",{});
        
      // }
      
    }
    
  };

  const handleDate=(date:any,dateString:any)=>{

    if(date){
      setcreateTask({...createTask, dueDate:date,dueError:false});
    }else{
      setcreateTask({...createTask, dueDate:"",dueError:true});
    }
    
  };

  const  onCancel=()=>{
    setcreateTask({...createTask,taskName:"",description:"",nameError:false, assigneeError:false});
   
    if (!isContact && !isMySpace) {
      chatSideWindow(true, "tasklist", {});
    }
    else if (isMySpace) {
      chat_reducer.isWindowSlide && ChatService.rightSideToogle();
     } else {
      props.handleToggle();
    }
  };

  const handleChange=(e:any)=>{
    if(e.target.name === 'taskName'){
      setcreateTask({...createTask,nameError:false, [e.target.name]: e.target.value});
    }
    else{
      setcreateTask({...createTask,[e.target.name]: e.target.value});
    }
  };

  const onChangeSelectMembers =(e:any)=>{
    
    let {userdetails}:LoginState = store.getState().loginReducer;
    let contact:any=
    e.map((item:string)=>
    {
      return getcontactDetail(item.toString(),selectMember.contactList,userdetails);
    });
    setselectMember({
      ...selectMember, selectedmember: e,
      searchContactList: selectMember.contactList,contactDetail:contact
    });
    setcreateTask({...createTask, assigneeError:false,assigneeArray:e});
  };




  const onSearchMembers = (value: any) => {
    let response = SearchFilter(selectMember.contactList, value.toLowerCase());
    setselectMember({ ...selectMember, searchContactList: response });
  
  };
  let len = Math.ceil((selectMember?.searchContactList?.length / 8));
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
  return (
    <>
      <div className={`customdates ${styles.rightsidebar}`}>
        <div className={styles.toplayers}>
          <h3>New Task</h3>
          <span className="icon_close" onClick={onCancel}></span>
        </div>
        <div className={styles.middlelayers}>
          <label>Task Name</label>
          <URInput placeHolder="Name the Task" name="taskName" maxLength = "40"
            className={`${styles.normalinput} cusinputs ${createTask?.nameError ? "errorInput":""}`} value={createTask.taskName} onChange={handleChange}/>
          {createTask?.nameError && <span className="error">This task needs a name</span>}
          <label>Assigned To</label>
          <div className={styles.insideicon}>
            <img src={taskimg2} alt="" />
            <Select
              mode="multiple"
              onChange={(e: any) => onChangeSelectMembers(e)}
              style={{ width: '100%' }}
              value={selectMember.selectedmember}
              placeholder="Select Employee"
              showSearch={true}
              className={`newselects taskcreations ${createTask?.assigneeError ? "errorInput":""}`}>
              {Array.isArray(selectMember?.searchContactList) && selectMember?.searchContactList?.map((contact:any,index:any)=>{
               
               // let name= contact?.caller_id ?contact?.caller_id : contact?.team_name;
                return(
             
                  <Option key={index}
                    value={contact.sip_login_id}>
                    <div className="dropdowndesign">
                      <div className="usergroupss">
                        <URAvatarGroup className={`lefts size20 colorBG${random_color[index]}`} profileInfo={<>
                          {contact.profile_image_thumbnail ?
                            <img src={contact.profile_image_thumbnail} alt="" className={styles.imgSelected}/> :
                            <span>{contact?.first_name?.charAt(0)?.toUpperCase()+contact?.last_name?.charAt(0)?.toUpperCase()}</span>}
                          <URStatusDot
                            className={userStatusColor(contact?.user_status,'small')}/>
                        </> } />
                      </div>
                      <div className="names">{contact?.caller_id}</div>
                      <div className="ext">{contact?.ext}</div>
                    </div>
                  </Option>
              
                );

            
              })  }
         
            </Select>
          </div>
          {createTask?.assigneeError && <span className="error">Assign task to Someone</span>}
          <label>Due Date</label>
          <div className={`${createTask.dueError ? "errorInput":""} ${styles.insideicon}`}>
            <DatePicker className="customDatepicker datepickerTaskCreation"
              disabledDate={(e) => disabledDate(new Date(), e)}
              defaultValue={moment(createTask.dueDate)}
              onChange={(date: any, dateString: any)=>handleDate(date, dateString)} format="DD/MM/YYYY"
              dropdownClassName='datepickerDropdown' placeholder='Due date' /></div>
          {createTask.dueError && <span className="error">Task due date required</span>}
          <label>Description</label>
          <TextArea name="description" onChange={handleChange}
            value={createTask.description} placeholder="Write a task description"></TextArea>
        </div>
        <div className={styles.bottomlayers}>
          <URButton name="Cancel" onClick={onCancel} className='urButton buttonWhite buttonMd mr8' />
          <URButton name="Save" onClick={onSaveTask} className='urButton buttonBlue buttonMd' />
        </div>
      </div>
    </>
  );

}
